import React, { Component } from 'react';
import Auth from '../../../Auth';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import { Link } from 'react-router-dom';
import Icon from '../../partials/Icon';

class Dashboard extends Component {
    state = {
        groups: {
            id: '',
            title: '',
            school: {
                name: ''
            }
        }
    }

    componentWillMount() {
        // Ta bort klass som används för att inloggning ska köra ett mörkt tema
        document.getElementById('body').className=''
    }

    componentDidMount() {
        var self = this;

        // Hämta alla projekt
        axios.get(API_URL+'/admin/groups')
            .then(response => {
                self.setState({ groups: response.data });
            })
            .catch(error => {
                // Om användaren saknar rättigheter så loggas man ut
                if (error.response && error.response.status === 401) {
                    Auth.logout();
                }
            });
    }

    render() {
        const { groups } = this.state;

        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <Link to={ `/admin/me` } className="user-button"></Link>
                    </div>
                </div>

                <div className="container">
                    <div className="content">
                        <h1>Överblick</h1>

                        <div className="block">
                            <div className="header">
                                <h4>Grupper</h4>
                            </div>

                            <div className="body">
                                { this.state.groups && this.state.groups.length > 0 ? (
                                    <ul className="has-icons">
                                        { Object.keys(groups).map(function(key) {
                                            return (
                                                <li key={ key }>
                                                    <Icon icon="group" color="pink" />
                                                    <Link to={ `/admin/groups/${ groups[key].id }` }>{ groups[key].name }</Link>
                                                    <Link className="right" to={ `/admin/groups/${ groups[key].id }` }>Hantera</Link>
                                                </li>
                                            )

                                        }) }
                                    </ul>
                                ) : (
                                    <span>Det finns inga grupper.</span>
                                ) }
                            </div>
                        </div>

                        <button className="button m-top-l" onClick={ Auth.logout }>Logga ut</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/admin/Dashboard/index.js